import { render, staticRenderFns } from "./invitation-popup.vue?vue&type=template&id=ebb6c2be&scoped=true"
import script from "./invitation-popup.vue?vue&type=script&lang=js"
export * from "./invitation-popup.vue?vue&type=script&lang=js"
import style0 from "./invitation-popup.vue?vue&type=style&index=0&id=ebb6c2be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb6c2be",
  null
  
)

export default component.exports